import { ApiRoutes } from '@/services/ApiRoutes.js';
import { BackendAPI } from '@/services/BackendAPI.js';

export default {
  all() {
    return BackendAPI('get', ApiRoutes.frozen.all());
  },
  get(id, data = {}) {
    return BackendAPI('get', ApiRoutes.frozen.get(id), data);
  },
  restoreFrozen(id, data = {}) {
    return BackendAPI('put', ApiRoutes.frozen.restoreFrozen(id), data);
  },
  // Note: for testing purpose, please delete after finish testing
  // testScheduledFunction() {
  //   return BackendDownloadFileAPI('post', ApiRoutes.student.testScheduledFunction());
  // },
  // testScheduledFunction() {
  //   return BackendDownloadFileAPI('delete', ApiRoutes.student.testScheduledFunction());
  // },
};
